module.exports = __webpack_public_path__ + "static/media/new-post.266538a9.svg";